import React, { useState } from "react";
import { Card, Col, Form, Input, Button, Checkbox, PageHeader, Alert, Row, Spin } from "antd";
import CustomBtn from "../../../components/Button";
import { useDispatch, useSelector } from "react-redux";
import PinCodeDialog from "../../../components/Dialog/pincode-dialog";
import { showDialog } from "../../../redux/dialog/dialog-slice";
import { handleApiError } from "../../../utils/errorHandler";
import { useBillSonabelPOSTPAIDPayMutation, useBillFeesMutation, useBillSonabelPOSTPAIDGetMutation } from "../../../redux/bills/bill-sonabel-postpaid-api";
import { sonabelPost } from "../../../utils/globalVars";


export function BillSonabelPOSTPAIDPage() {
    const dispatch = useDispatch();
    const [form] = Form.useForm();
    const { currentAgent } = useSelector((state) => state.auth);
    const [collecte, setCollecte] = useState({});
    const [receiver, setReceiver] = useState("");
    const [billGetInfo] = useBillSonabelPOSTPAIDGetMutation();
    const [frais, setFrais] = useState([]);
    const dialog = useSelector((state) => state.dialog);
    const [isLoading, setIsLoading] = useState(false);
    const [billFees] = useBillFeesMutation();
    const [billSonabelPay] = useBillSonabelPOSTPAIDPayMutation();
    const [invoices, setInvoices] = useState([]);
    const [selectedInvoices, setSelectedInvoices] = useState([]);
    const [counter, setCounter] = useState();
    const [transactionId, setTransactionId] = useState();
    const [codecity, setCodecity] = useState();
    const [error, setError] = useState();

    const handleTransaction = async (value) => {
        setIsLoading(true);
        setCollecte({});
        setReceiver("");
        setCounter(value.counter);
        setCodecity(value.code_city);
        const data = {
            ...value,
            "pincode": "",
            "service_name": "POSTPAID",
            "country": currentAgent.country,
            "token": currentAgent.access_token,
        }
        billGetInfo(data)
            .unwrap()
            .then((res) => {
                setTransactionId(res.snbl_transaction_id)
                setIsLoading(false);
                // setReceiver(value.receiver_msisdn);
                setInvoices(res.invoices)
            })
            .catch((error) => {
                setIsLoading(false);
                setError(error.data.error)
            });
    }

    const calculateTotalAmount = (invoices) => {
        return invoices.reduce((total, invoice) => total + invoice.amount, 0);
    };


    const handleFees = async () => {
        setIsLoading(true);
        const data = {
            operation: "COLLECTE",
            receiver: sonabelPost,
            montant: calculateTotalAmount(selectedInvoices),
            country: currentAgent.country,
            pincode: "",
            token: currentAgent.access_token,
        };
        billFees(data)
            .unwrap()
            .then((res) => {
                setIsLoading(false);
                setFrais(res);
                dispatch(showDialog({ isPinCode: true }));
            })
            .catch((error) => {
                setIsLoading(false);
                if ((error.data.status === "TOKEN_EXPIRED") || (error.data.status === "Unauthorized"))
                    dispatch(showDialog({ isLockscreen: true }));
                else {
                    form.resetFields();
                    dispatch(showDialog({ isError: true, errorMessage: handleApiError(error.data) }));
                }
            });
    };

    const handlePay = async (pin) => {
        setIsLoading(true);
        const data = {
            counter: counter,
            amount: calculateTotalAmount(selectedInvoices),
            snbl_transaction_id: transactionId,
            service_name: "POSTPAID",
            code_city: codecity,
            receiver_msisdn: receiver,
            pincode: pin,
            country: currentAgent.country,
            token: currentAgent.access_token,
        };
        billSonabelPay(data)
            .unwrap()
            .then(() => {
                setInvoices([]);
                setIsLoading(false);
                dispatch(showDialog({ isSuccess: true, successMessage: "Transaction effectuée avec succès" }));
                form.resetFields();
            })
            .catch((error) => {
                setIsLoading(false);
                if ((error.data.status === "TOKEN_EXPIRED") || (error.data.status === "Unauthorized"))
                    dispatch(showDialog({ isLockscreen: true }));
                else
                    dispatch(showDialog({ isError: true, errorMessage: handleApiError(error.data) }));
            });
    };

    const getPin = (pin) => handlePay(pin);

    const resumeJson = {
        "title": `Paiement Sonabel POSTPAID`,
        "message": `Vous allez payer une facture numéro ${collecte?.snbl_transaction_id} d'un montant de ${calculateTotalAmount(selectedInvoices)} FCFA .`,
        "fees": frais.fees
    }

    const handleCheckboxChange = (invoice) => {
        setSelectedInvoices((prevSelected) => {
            const alreadySelected = prevSelected.some(selected => selected.num_order === invoice.num_order);

            if (alreadySelected) {
                // Si la facture est déjà sélectionnée, désélectionner toutes les factures supérieures
                return prevSelected.filter(selected => selected.num_order <= invoice.num_order);
            } else {
                // Sinon, sélectionner la facture et toutes les factures inférieures ou égales
                const invoicesToSelect = invoices.filter(inv => inv.num_order <= invoice.num_order);
                return [...prevSelected, ...invoicesToSelect.filter(inv => !prevSelected.some(selected => selected.num_order === inv.num_order))];
            }
        });
    };


    return (
        <div className="default-page">
            {dialog.isPinCode && <PinCodeDialog resume={resumeJson} pinCode={getPin} />}

            <PageHeader title={`Sonabel POSTPAID`} />
            <Spin tip="Chargement..." spinning={isLoading}>
                <Col lg={12} xs={24}>
                    <Card key="sendInfo">
                        <Form
                            name="basic"
                            form={form}
                            layout="vertical"
                            onFinish={handleTransaction}>
                            <Form.Item label="Numero du client" name="receiver_msisdn" rules={[{ required: true, message: "Veuillez saisir un numéro du client" }]}>
                                <Input
                                    className="form-control"
                                    placeholder="Numero du client"
                                />
                            </Form.Item>
                            <Form.Item
                                label="Numero du compteur"
                                name="counter"
                                rules={[{ required: true, message: "Veuillez saisir le numéro du compteur" }]}>
                                <Input
                                    className="form-control"
                                    placeholder="Numero du compteur"
                                />
                            </Form.Item>
                            <Form.Item
                                label="Numero de la ville"
                                name="code_city"
                                rules={[{ required: true, message: "Veuillez saisir le numéro de la ville" }]}>
                                <Input
                                    className="form-control"
                                    placeholder="Numero de la ville"
                                />
                            </Form.Item>
                            <Form.Item>
                                <CustomBtn title={"Chercher"} />
                            </Form.Item>
                        </Form>
                    </Card>
                    <br />
                    {error && <Form.Item> <Alert message={error} type="error" showIcon /></Form.Item>}
                </Col>
                {(invoices.length !== 0) && (
                    <div>
                        <br />
                        <h4>Veuillez selectionner un ou plusieurs factures à payer</h4>
                        {
                            invoices.length > 0 ?
                                <Row gutter={24}>
                                    {invoices.map((repo) => {
                                        const isChecked = selectedInvoices.some(selected => selected.num_order === repo.num_order);
                                        return (
                                            <Col lg={6} xs={24} key={repo.num_order}>
                                                <div className="invoices-content">
                                                    <Card>
                                                        <Checkbox onChange={() => handleCheckboxChange(repo)} checked={isChecked}>
                                                            <div>Facture: <span style={{ color: "gray", fontWeight: "400" }}>{repo.num_order}</span></div>
                                                            <div>Client: <span style={{ color: "gray", fontWeight: "400" }}>{repo.customer_name}</span></div>
                                                            <div>Montant: <span style={{ color: "red", fontWeight: "500" }}>{repo.amount.toLocaleString('fr-FR')} FCFA</span></div>
                                                        </Checkbox>
                                                    </Card>
                                                </div>
                                                <br />
                                            </Col>
                                        );
                                    })}
                                </Row> :
                                <Col lg={12} xs={24}>
                                    <Card style={{ textAlign: 'center' }}>Il n'a aucune facture à payer pour ce numéro</Card>
                                </Col>
                        }
                        <div>
                            {selectedInvoices.length > 0 && <Button className="ant-btn btn btn-secondary" type="primary" onClick={() => handleFees()}>{selectedInvoices.length} facture(s) à payer </Button>}
                        </div>
                    </div>
                )}
            </Spin>
        </div>
    );
}

export default BillSonabelPOSTPAIDPage;